import { timeSignatureLimits } from '../functions'

export const isValidTimeSignature = (top: number, bottom: number) => {
	if (![4, 8, 16].includes(bottom)) {
		return false
	}

	const limits: { upper: number; lower: number } | undefined = timeSignatureLimits(bottom)

	if (!limits) {
		return false
	}

	return top >= limits.lower && top <= limits.upper
}
